export const xsmallIconSize = 1.5;
export const smallIconSize = 2;
export const mediumIconSize = 3;
export const largeIconSize = 4;
export const xlIconSize = 6;
